// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DatapointBenchmarkFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}
export function DatapointBenchmarkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'type': value.type,
    };
}
/**
* @export
* @enum {string}
*/
export var DatapointBenchmarkTypeEnum;
(function (DatapointBenchmarkTypeEnum) {
    DatapointBenchmarkTypeEnum["Privatebenchmark"] = "privatebenchmark";
    DatapointBenchmarkTypeEnum["Publicbenchmark"] = "publicbenchmark";
})(DatapointBenchmarkTypeEnum || (DatapointBenchmarkTypeEnum = {}));
